import { Button } from '@workflow/ui'
import { navigate } from '@/app/router'
import { OPS_PAGE_MEASURE } from './layout'

/**
 * Nowhere: the address names no page of the studio. The words sit plainly at
 * the top, the way every page begins — and the numeral sits enormous at the
 * bottom-right, a quiet watermark in both themes, with the one way out
 * beside the words. Nothing else competes with it.
 */
export function NotFoundPage() {
  return (
    <div
      className="relative mx-auto flex min-h-full w-full flex-col overflow-hidden px-4 pt-20 pb-16 sm:px-8 sm:pt-24"
      style={{ maxWidth: OPS_PAGE_MEASURE }}
    >
      <div className="relative z-10 min-w-0">
        <h1 className="wf-display text-foreground">Nothing here.</h1>
        <p className="mt-1.5 max-w-[60ch] text-ui text-muted-foreground">
          The address does not name a page of this studio.
        </p>
        <div className="mt-6">
          <Button size="sm" variant="primary" onClick={() => navigate({ name: 'home' })}>
            Back to home
          </Button>
        </div>
      </div>
      <div
        aria-hidden
        className="pointer-events-none absolute -right-4 -bottom-10 font-display text-foreground/[0.08] select-none sm:-right-8"
        style={{ fontSize: 'clamp(12rem, 34vw, 30rem)', lineHeight: 0.8 }}
      >
        404
      </div>
    </div>
  )
}
